import { render, staticRenderFns } from "./welcome-adv.vue?vue&type=template&id=99edd610&scoped=true"
import script from "./welcome-adv.vue?vue&type=script&lang=js"
export * from "./welcome-adv.vue?vue&type=script&lang=js"
import style0 from "./welcome-adv.vue?vue&type=style&index=0&id=99edd610&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99edd610",
  null
  
)

export default component.exports